import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { Pack } from "../../packs.types";
import { requestCreatePack } from "./createPack.request";

const useCreatePack = (
  options?: MutationOptions<Pack, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreatePack,
    ...options
  });
};

export default useCreatePack;
